import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlueCircleCheckbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #1e88e5;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M17,9c0,4.42-3.58,8-8,8S1,13.42,1,9,4.58,1,9,1s8,3.58,8,8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M8,12c-.26,0-.51-.1-.71-.29l-2-2c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.29,1.29,3.29-3.29c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-4,4c-.2.2-.45.29-.71.29Z"
		})
	]
});
export default SvgBlueCircleCheckbox;
